module.exports = __webpack_public_path__ + "static/img/filing.d0289dc0.png";